import { getCurrency } from '@common/utils/currency'

import type { PpvMediaSet } from '@/modules/tracking/ppv/types.ts'
import { getPercentValue } from '@/utils/helpers'

import { PpvStatsItem } from '../PpvStatsItem.tsx'

interface PpvMessagesStatsProps {
  mediaSet: PpvMediaSet
  showCents?: boolean
}

export const PpvMessagesStats = ({
  mediaSet,
  showCents,
}: PpvMessagesStatsProps) => {
  return (
    <div className="mb-8 mt-6 flex flex-wrap gap-8">
      {mediaSet && (
        <div className="flex w-full gap-2">
          <div className="flex w-full items-center justify-around rounded-lg bg-card p-6">
            <div>
              <h3 className="text-2xl font-semibold text-title">
                {mediaSet.sentAmount}x
              </h3>
              <div className="text-sm font-medium leading-6 text-text-sub">
                Sent
              </div>
            </div>
            <div className="h-[58px] border" />
            <div>
              <h3 className="text-2xl font-semibold text-title">
                {mediaSet.boughtAmount}x
              </h3>
              <div className="text-sm font-medium leading-6 text-text-sub">
                Bought
              </div>
            </div>
          </div>

          <PpvStatsItem
            field="Avg. Net Price"
            value={getCurrency(mediaSet.averagePrice, showCents ? 2 : 0)}
          />

          <PpvStatsItem
            field="Net Revenue"
            value={getCurrency(mediaSet.netRevenue, showCents ? 2 : 0)}
          />

          <PpvStatsItem
            field="Purchase Rate"
            value={getPercentValue(mediaSet.purchaseRate)}
          />
        </div>
      )}
    </div>
  )
}
